import React, { useState, ChangeEvent, useCallback, useEffect, useRef } from "react";
import Box from "@mui/material/Box";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import { ReactComponent as ChevronRightIcon } from "../../../../assets/chevron-right-icon.svg";

import { ReactComponent as ChevronLeftIcon } from "../../../../assets/chevron-left-icon.svg";
import Typography from "@mui/material/Typography";
import { ReactComponent as PossibleTrajectories } from "../../../../assets/possible-trajectories.svg";
import { FormControl, IconButton, useTheme } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import "../../../../App.scss";
import { FormGroup, FormControlLabel } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import { AccountCircleOutlined, Close, FilterList, Search } from "@mui/icons-material";

import { setFilterRole, setRoleInfo, stateRelatedRoles } from "../../../../store/ducks/relatedRoles";

import { useDispatch, useSelector } from "react-redux";
import { areas } from "../../../../constants/colorsArea";
import PopperComponent from "../popper";
import { areaIds, objFilterProfile, objFilterTrajectory } from "../../../../constants/idsFilters";
import { BoxContainer, BoxFilter, ButtonOpenFilter, IOSSwitch, SelectComponent } from "./styles";
import { isMobile } from "../../../../utils/screenValidations/screen";
import { mouseLeave } from "../../../../libs/d3jsmap/hook";
import { roleSelected } from "../../../../utils/roleSelected";
import { useSearchParams } from "react-router-dom";

interface SwitchState {
    analitico: boolean;
    tatico: boolean;
    operacional: boolean;
    estrategico: boolean;
    comercial: boolean;
}

function useOutsideAlerter(ref: React.MutableRefObject<any>, callback: () => void) {
    useEffect(() => {
        function handleClickOutside(event: any) {
            if (
                (ref.current && !ref.current.contains(event.target) && document.querySelector('[opensidebar="true"]')) ||
                event.srcElement.id === "filter-mobile" ||
                (event.srcElement.nodeName === "path" && event.srcElement.parentNode.id === "filter-mobile")
            ) {
                callback();
                return;
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [callback, ref]);
}

const FilterMenu = () => {
    const {
        colors: { neutral_colors, brand_colors_primary },
    } = useTheme();

    const [params] = useSearchParams();

    const [selectedOption, setSelectedOption] = useState("");
    const [openSideBar, setOpenSideBar] = useState(!isMobile());
    const [searchValue, setSearchValue] = useState("");
    const { relatedRole, filterRole } = useSelector(stateRelatedRoles);
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);
    const [switchState, setSwitchState] = useState<SwitchState>({
        analitico: true,
        tatico: true,
        operacional: true,
        estrategico: true,
        comercial: true,
    });
    const [switchStateTrajectory, setSwitchStateTrajectory] = useState<Record<string, boolean>>({
        financial: true,
        business: true,
        people_management: true,
        technology: true,
    });

    const cleanSelected = () => {
        mouseLeave();
        dispatch(setRoleInfo(null));
        roleSelected().forEach((el) => el?.classList.remove("clicked-node"));
    };

    const filterSidebar = (trjectoryObj = {}, profileObj = {}, area = null) => {
        const trajectory = Object.entries(trjectoryObj)
            .filter(([_, value]) => value)
            .map(([key]) => key);
        const profile = Object.entries(profileObj)
            .filter(([_, value]) => value)
            .map(([key]) => key);

        document.querySelectorAll("g.nodes").forEach((element) => {
            const profileAttr = element.getAttribute("profile-id");
            const trajectoryAttr = element.getAttribute("trajectory-id");
            const areaAttr = element.getAttribute("areas-ref");

            const styledElement = element as HTMLElement;
            if (
                !trajectory.includes(objFilterTrajectory[trajectoryAttr as any]) ||
                !profile.includes(objFilterProfile[profileAttr as any]) ||
                (!!area && String(area) != areaAttr)
            ) {
                styledElement.style.display = "none";
            } else {
                styledElement.style.display = "";
            }
        });
    };

    const filterTravel = useCallback(
        (trajectory_id: number) => {
            if (!relatedRole) return;
            return relatedRole?.nodes.filter((el) => el?.trajectory_id === trajectory_id)?.length || 0;
        },
        [relatedRole]
    );

    const handleSearchChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
        if (value.length <= 2) {
            cleanSelected();
        }
        setSearchValue(value);
    };
    const handleAreaFilterChange = ({ target: { value } }: any) => {
        cleanSelected();
        setSelectedOption(value as string);

        const selectedAreaId = areaIds[value.replace(/[^A-Za-z]/gi, "")];
        filterSidebar(switchStateTrajectory, switchState, selectedAreaId);
    };

    const handleSwitchChange = (event: ChangeEvent<HTMLInputElement>) => {
        cleanSelected();
        const { name, checked } = event.target;
        const newState: SwitchState = {
            ...switchState,
            [name]: checked,
        };

        setSwitchState((prev) => ({
            ...prev,
            ...newState,
        }));

        filterSidebar(switchStateTrajectory, newState, areaIds[selectedOption.replace(/[^A-Za-z]/gi, "")]);
    };

    const handleSwitchTrajectory = (event: ChangeEvent<HTMLInputElement>) => {
        cleanSelected();

        const { name, checked } = event.target;
        const newState: any = {
            ...switchStateTrajectory,
            [name]: checked,
        };
        setSwitchStateTrajectory((prev) => ({
            ...prev,
            ...newState,
        }));
        filterSidebar(newState, switchState, areaIds[selectedOption.replace(/[^A-Za-z]/gi, "")]);
    };

    useEffect(() => {
        if (filterRole) {
            setOpenSideBar(false);
        }
    }, [filterRole]);

    useOutsideAlerter(wrapperRef, () => {
        if (isMobile()) {
            setOpenSideBar(!openSideBar);
        }
    });

    useEffect(() => {
        if (relatedRole.nodes.length > 0) {
            var objTrajectory: any = switchStateTrajectory;
            var objProfile: any = switchState;
            var areaFilter: any = null;
            if (!!params.get("perfil")) {
                const newObj: any = {
                    analitico: false,
                    tatico: false,
                    operacional: false,
                    estrategico: false,
                    comercial: false,
                };
                params!
                    .get("perfil")
                    ?.split(",")
                    .map((item) => {
                        newObj[item] = true;
                    });

                objProfile = {
                    ...newObj,
                };

                setSwitchState((prev) => ({
                    ...prev,
                    ...objProfile,
                }));
            }

            if (!!params.get("trajectory")) {
                const newObj: any = {
                    financial: false,
                    business: false,
                    people_management: false,
                    technology: false,
                };
                params!
                    .get("trajectory")
                    ?.split(",")
                    .map((item) => {
                        newObj[item] = true;
                    });

                objTrajectory = {
                    ...newObj,
                };

                setSwitchStateTrajectory((prev) => ({
                    ...prev,
                    ...objTrajectory,
                }));
            }
            if (!!params.get("role")) {
                const roleFilterByParam = relatedRole?.nodes?.find((el) => el.role_id == Number(params.get("role")));
                if (roleFilterByParam) {
                    setSearchValue(roleFilterByParam.role);
                    cleanSelected();
                    dispatch(setFilterRole(roleFilterByParam));
                    if (isMobile()) {
                        setOpenSideBar(false);
                    }
                }
            } else {
                if (!!params.get("area")) {
                    const areaParam = params.get("area") as any;
                    if (areaIds[areaParam.replace(/[^A-Za-z]/gi, "")]) {
                        setSelectedOption(areaParam);
                        areaFilter = areaIds[areaParam.replace(/[^A-Za-z]/gi, "")];
                    }
                }

                if (!!params.get("perfil") || !!params.get("trajectory") || !!params.get("area")) {
                    setTimeout(() => {
                        filterSidebar(objTrajectory, objProfile, areaFilter);
                    }, 1000);
                }
            }
        }
    }, [relatedRole, params]);

    return (
        <BoxFilter opensidebar={String(openSideBar)}>
            <BoxContainer opensidebar={String(openSideBar)} searchvalue={searchValue}>
                <div ref={wrapperRef} style={{ display: "flex" }}>
                    <List style={{ width: "100%" }} disablePadding>
                        <ListItem disablePadding style={{ background: brand_colors_primary.noir_blue }}>
                            <Box padding={"16px"} width={"100%"}>
                                <Input
                                    className="placeholder-red-300"
                                    disableUnderline={true}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <Search style={{ color: neutral_colors.stone_gray }} />
                                        </InputAdornment>
                                    }
                                    endAdornment={
                                        searchValue.length >= 2 && (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        setSearchValue("");
                                                        cleanSelected();
                                                    }}
                                                >
                                                    <Close style={{ color: neutral_colors.stone_gray }} />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }
                                    sx={{
                                        input: {
                                            "::placeholder": {
                                                color: "white",
                                                opacity: 1,
                                            },
                                            color: "#fff",
                                            fontWeight: "bold",
                                        },
                                    }}
                                    style={{
                                        border: "none",
                                        color: "white",
                                        width: "100%",
                                    }}
                                    placeholder="Buscar cargo"
                                    value={searchValue}
                                    onChange={handleSearchChange}
                                />
                            </Box>
                        </ListItem>
                        <Divider style={{ backgroundColor: `${neutral_colors.stone_gray}66` }} />

                        {!searchValue || searchValue.length < 2 ? (
                            <>
                                <ListItem disablePadding style={{ width: "100%" }}>
                                    <Box padding={"8px 16px"} width={"100%"}>
                                        <FormControl style={{ width: "100%" }}>
                                            <SelectComponent value={selectedOption} onChange={handleAreaFilterChange}>
                                                <MenuItem disabled selected value="">
                                                    <Typography fontFamily="IliaMontserrat">Filtrar por área</Typography>
                                                </MenuItem>
                                                <MenuItem value={"Selecionar todos"}>
                                                    <Typography fontFamily="IliaMontserrat">Selecionar todos</Typography>
                                                </MenuItem>
                                                <MenuItem value={"Business"}>
                                                    <Typography fontFamily="IliaMontserrat">Business</Typography>
                                                </MenuItem>
                                                <MenuItem value={"Finance"}>
                                                    <Typography fontFamily="IliaMontserrat">Finance</Typography>
                                                </MenuItem>
                                                <MenuItem value={"Legal"}>
                                                    <Typography fontFamily="IliaMontserrat">Legal</Typography>
                                                </MenuItem>
                                                <MenuItem value={"Operations"}>
                                                    <Typography fontFamily="IliaMontserrat">Operations</Typography>
                                                </MenuItem>
                                                <MenuItem value={"Ops-Non-Billable"}>
                                                    <Typography fontFamily="IliaMontserrat">Ops Non-Billable</Typography>
                                                </MenuItem>
                                                <MenuItem value={"People"}>
                                                    <Typography fontFamily="IliaMontserrat">People</Typography>
                                                </MenuItem>
                                                <MenuItem value={"People-Operations"}>
                                                    <Typography fontFamily="IliaMontserrat">People Operations</Typography>
                                                </MenuItem>
                                            </SelectComponent>
                                        </FormControl>
                                    </Box>
                                </ListItem>
                                <Divider style={{ backgroundColor: `${neutral_colors.stone_gray}66` }} />

                                <Box sx={{ padding: "32px 8px" }} width={"100%"}>
                                    <Box sx={{ gap: "8px 16px", display: "flex", marginBottom: 2, marginLeft: 2 }} width={"100%"}>
                                        <AccountCircleOutlined style={{ color: neutral_colors.stone_gray }} />
                                        <Typography
                                            sx={{ display: "flex", alignItems: "center" }}
                                            fontFamily="IliaOpenSansSemibold"
                                            fontWeight="600"
                                            fontSize="16px"
                                            lineHeight="21.79px"
                                            color="#9192AD"
                                        >
                                            Perfil
                                        </Typography>
                                    </Box>
                                    <ListItem disablePadding style={{ width: "100%" }}>
                                        <FormGroup
                                            style={{
                                                gap: "12px",
                                                width: "100%",
                                                padding: "0 16px 0 0",
                                            }}
                                        >
                                            <FormControlLabel
                                                control={
                                                    <>
                                                        <PopperComponent text="Foco na análise de dados, resolução de problemas e geração de insights." />
                                                        <IOSSwitch checked={switchState.analitico} onChange={handleSwitchChange} name="analitico" />
                                                    </>
                                                }
                                                label={
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            flexGrow: 1,
                                                            textAlign: "start",
                                                            fontWeight: 600,
                                                            fontFamily: "IliaOpenSansSemibold",
                                                            fontSize: "16px",
                                                            lineHeight: "21.79px",
                                                            color: "#F7F7FF",
                                                        }}
                                                    >
                                                        Perfil Analítico
                                                    </Typography>
                                                }
                                                labelPlacement="start"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <>
                                                        <PopperComponent text="Habilidade em desenvolver e implementar estratégias para alcançar objetivos de curto a médio prazo." />
                                                        <IOSSwitch
                                                            size="medium"
                                                            checked={switchState.tatico}
                                                            onChange={handleSwitchChange}
                                                            name="tatico"
                                                        />
                                                    </>
                                                }
                                                label={
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            flexGrow: 1,
                                                            textAlign: "start",
                                                            fontWeight: 600,
                                                            fontFamily: "IliaOpenSansSemibold",
                                                            fontSize: "16px",
                                                            lineHeight: "21.79px",
                                                            color: "#F7F7FF",
                                                        }}
                                                    >
                                                        Perfil Tático
                                                    </Typography>
                                                }
                                                labelPlacement="start"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <>
                                                        <PopperComponent text="Responsável pela execução prática e gerenciamento das operações diárias." />
                                                        <IOSSwitch
                                                            checked={switchState.operacional}
                                                            onChange={handleSwitchChange}
                                                            name="operacional"
                                                        />
                                                    </>
                                                }
                                                label={
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            flexGrow: 1,
                                                            textAlign: "start",
                                                            fontWeight: 600,
                                                            fontFamily: "IliaOpenSansSemibold",
                                                            fontSize: "16px",
                                                            lineHeight: "21.79px",
                                                            color: "#F7F7FF",
                                                        }}
                                                    >
                                                        Perfil Operacional
                                                    </Typography>
                                                }
                                                labelPlacement="start"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <>
                                                        <PopperComponent text="Visão de longo prazo e formulação de planos para o sucesso futuro." />
                                                        <IOSSwitch
                                                            checked={switchState.estrategico}
                                                            onChange={handleSwitchChange}
                                                            name="estrategico"
                                                        />
                                                    </>
                                                }
                                                label={
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            flexGrow: 1,
                                                            textAlign: "start",
                                                            fontWeight: 600,
                                                            fontFamily: "IliaOpenSansSemibold",
                                                            fontSize: "16px",
                                                            lineHeight: "21.79px",
                                                            color: "#F7F7FF",
                                                        }}
                                                    >
                                                        Perfil Estratégico
                                                    </Typography>
                                                }
                                                labelPlacement="start"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <>
                                                        <PopperComponent text="Combinação entre perfil analítico, operacional e tático focado na identificação de oportunidades de negócio buscando atingimento de metas de curso, médio e longo prazo." />
                                                        <IOSSwitch checked={switchState.comercial} onChange={handleSwitchChange} name="comercial" />
                                                    </>
                                                }
                                                label={
                                                    <Typography
                                                        variant="body1"
                                                        sx={{
                                                            flexGrow: 1,
                                                            textAlign: "start",
                                                            fontWeight: 600,
                                                            fontFamily: "IliaOpenSansSemibold",
                                                            fontSize: "16px",
                                                            lineHeight: "21.79px",
                                                            color: "#F7F7FF",
                                                        }}
                                                    >
                                                        Perfil Comercial
                                                    </Typography>
                                                }
                                                labelPlacement="start"
                                            />
                                        </FormGroup>
                                    </ListItem>
                                </Box>
                                <Divider style={{ backgroundColor: `${neutral_colors.stone_gray}66` }} />
                                <Box sx={{ padding: "32px 8px" }} width={"100%"}>
                                    <Box sx={{ display: "flex", marginLeft: 2, marginBottom: 2 }} width={"100%"}>
                                        <PossibleTrajectories />
                                        <Typography
                                            sx={{ display: "flex", alignItems: "center" }}
                                            fontFamily="IliaOpenSansSemibold"
                                            fontWeight="600"
                                            fontSize="16px"
                                            lineHeight="21.79px"
                                            color="#9192AD"
                                        >
                                            Trajetórias Possíveis
                                        </Typography>
                                    </Box>
                                    <ListItem disablePadding>
                                        <FormGroup
                                            style={{
                                                gap: "12px",
                                                width: "100%",
                                                padding: "0 16px 0 0px",
                                            }}
                                        >
                                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} ml={2}>
                                                <div
                                                    style={{
                                                        width: "12px",
                                                        height: "12px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#FFA02E",
                                                    }}
                                                />
                                                <FormControlLabel
                                                    sx={{
                                                        flex: 1,
                                                    }}
                                                    control={
                                                        <>
                                                            <PopperComponent text="Administra recursos financeiros, orçamentos e investimentos, visando a estabilidade e o planejamento estratégico da empresa." />
                                                            <IOSSwitch
                                                                checked={switchStateTrajectory.financial}
                                                                onChange={handleSwitchTrajectory}
                                                                name="financial"
                                                            />
                                                        </>
                                                    }
                                                    label={
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                "& .MuiFormControlLabel-root": {
                                                                    flex: 1,
                                                                },
                                                                display: "flex",
                                                                gap: 1,
                                                                flex: 1,
                                                                flexGrow: 1,
                                                                textAlign: "start",
                                                                fontWeight: 600,
                                                                fontFamily: "IliaOpenSansSemibold",
                                                                fontSize: "16px",
                                                                lineHeight: "21.79px",
                                                                color: "#F7F7FF",
                                                            }}
                                                        >
                                                            Financeira
                                                            <Typography
                                                                sx={{
                                                                    fontFamily: "IliaOpenSansSemibold",
                                                                    color: neutral_colors.stone_gray,
                                                                }}
                                                            >{`(${filterTravel(1)})`}</Typography>
                                                        </Typography>
                                                    }
                                                    color="green"
                                                    labelPlacement="start"
                                                />
                                            </Box>
                                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} ml={2}>
                                                <div
                                                    style={{
                                                        width: "12px",
                                                        height: "12px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#A25AF1",
                                                    }}
                                                />
                                                <FormControlLabel
                                                    sx={{
                                                        flex: 1,
                                                    }}
                                                    control={
                                                        <>
                                                            <PopperComponent text="Elabora estratégias comerciais, incluindo vendas, marketing e desenvolvimento de produtos, para fomentar o crescimento da empresa." />
                                                            <IOSSwitch
                                                                checked={switchStateTrajectory.business}
                                                                onChange={handleSwitchTrajectory}
                                                                name="business"
                                                            />
                                                        </>
                                                    }
                                                    label={
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                display: "flex",
                                                                gap: 1,
                                                                flexGrow: 1,
                                                                textAlign: "start",
                                                                fontWeight: 600,
                                                                fontFamily: "IliaOpenSansSemibold",
                                                                fontSize: "16px",
                                                                lineHeight: "21.79px",
                                                                color: "#F7F7FF",
                                                            }}
                                                        >
                                                            Negócios
                                                            <Typography
                                                                sx={{
                                                                    fontFamily: "IliaOpenSansSemibold",
                                                                    color: neutral_colors.stone_gray,
                                                                }}
                                                            >{`(${filterTravel(3)})`}</Typography>
                                                        </Typography>
                                                    }
                                                    labelPlacement="start"
                                                />
                                            </Box>
                                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} ml={2}>
                                                <div
                                                    style={{
                                                        width: "12px",
                                                        height: "12px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#FA4549",
                                                    }}
                                                />
                                                <FormControlLabel
                                                    sx={{
                                                        flex: 1,
                                                    }}
                                                    control={
                                                        <>
                                                            <PopperComponent text="Cuida do recrutamento, treinamento, desenvolvimento e bem-estar dos funcionários, buscando um ambiente positivo e o alinhamento com os objetivos da empresa." />
                                                            <IOSSwitch
                                                                checked={switchStateTrajectory.people_management}
                                                                onChange={handleSwitchTrajectory}
                                                                name="people_management"
                                                            />
                                                        </>
                                                    }
                                                    label={
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                flexGrow: 1,
                                                                display: "flex",
                                                                gap: 1,
                                                                textAlign: "start",
                                                                fontWeight: 600,
                                                                fontFamily: "IliaOpenSansSemibold",
                                                                fontSize: "16px",
                                                                lineHeight: "21.79px",
                                                                color: "#F7F7FF",
                                                            }}
                                                        >
                                                            Gestão de Pessoas
                                                            <Typography
                                                                sx={{
                                                                    fontFamily: "IliaOpenSansSemibold",
                                                                    color: neutral_colors.stone_gray,
                                                                }}
                                                            >{`(${filterTravel(2)})`}</Typography>
                                                        </Typography>
                                                    }
                                                    labelPlacement="start"
                                                />
                                            </Box>
                                            <Box display={"flex"} flexDirection={"row"} alignItems={"center"} ml={2}>
                                                <div
                                                    style={{
                                                        width: "12px",
                                                        height: "12px",
                                                        borderRadius: "50%",
                                                        backgroundColor: "#4AC8F5",
                                                    }}
                                                />
                                                <FormControlLabel
                                                    sx={{
                                                        flex: 1,
                                                    }}
                                                    control={
                                                        <>
                                                            <PopperComponent text="Responsável pela pesquisa, desenvolvimento, implementação e manutenção de soluções tecnológicas." />
                                                            <IOSSwitch
                                                                checked={switchStateTrajectory.technology}
                                                                onChange={handleSwitchTrajectory}
                                                                name="technology"
                                                            />
                                                        </>
                                                    }
                                                    label={
                                                        <Typography
                                                            variant="body1"
                                                            sx={{
                                                                flexGrow: 1,
                                                                display: "flex",
                                                                gap: 1,
                                                                textAlign: "start",
                                                                fontWeight: 600,
                                                                fontFamily: "IliaOpenSansSemibold",
                                                                fontSize: "16px",
                                                                lineHeight: "21.79px",
                                                                color: "#F7F7FF",
                                                            }}
                                                        >
                                                            Tecnologia
                                                            <Typography
                                                                sx={{
                                                                    fontFamily: "IliaOpenSansSemibold",
                                                                    color: neutral_colors.stone_gray,
                                                                }}
                                                            >{`(${filterTravel(4)})`}</Typography>
                                                        </Typography>
                                                    }
                                                    labelPlacement="start"
                                                />
                                            </Box>
                                        </FormGroup>
                                    </ListItem>
                                </Box>
                                <Divider style={{ backgroundColor: `${neutral_colors.stone_gray}66` }} />
                            </>
                        ) : (
                            relatedRole?.nodes
                                ?.filter((el) => el.role.toLowerCase().includes(searchValue.toLowerCase()))
                                ?.map((element: any) => {
                                    const isVisibleitem = document
                                        .querySelector(`#idNodes${element.role_id}`)
                                        ?.getAttribute("style")
                                        ?.includes("none");
                                    if (isVisibleitem) return null;
                                    return (
                                        <Box
                                            onClick={() => {
                                                if (!filterRole || filterRole?.role_id !== element.role_id) {
                                                    cleanSelected();
                                                    dispatch(setFilterRole(element));
                                                    if (isMobile()) {
                                                        setOpenSideBar(false);
                                                    }
                                                }
                                            }}
                                            sx={{ cursor: "pointer", width: "400px" }}
                                            padding={"8px 32px"}
                                            mt={2}
                                        >
                                            <Typography fontWeight={"bold"} color={areas[element.trajectory_id]?.color}>
                                                {areas[element.trajectory_id]?.trajectory}
                                            </Typography>
                                            <Typography color={"white"}>{element.role}</Typography>
                                            <Divider style={{ backgroundColor: `${neutral_colors.stone_gray}66`, marginTop: 16 }} />
                                        </Box>
                                    );
                                })
                        )}
                    </List>
                </div>
            </BoxContainer>
            <ButtonOpenFilter
                onClick={() => {
                    if (!isMobile()) {
                        setOpenSideBar(!openSideBar);
                    }
                }}
            >
                <FilterList id="filter-mobile" style={{ color: "white" }} />
                <div id="filter-desktop">{openSideBar ? <ChevronLeftIcon /> : <ChevronRightIcon />}</div>
            </ButtonOpenFilter>
        </BoxFilter>
    );
};

export default FilterMenu;
